import type { ComputedRef, Ref } from 'vue'
import { computed } from 'vue'
import { useDateFormat } from '@/composables/useDateFormat'

export function useBlogPostDateFormatter(
    date: Readonly<Ref<Date | undefined | null>>
): ComputedRef<string> {
    const formatDate = useDateFormat({
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    })

    return computed(() => {
        if (!date.value) {
            return ''
        }

        return formatDate(date.value)
    })
}
